<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M19.6303 4.27248L16.4433 10.0379L13.1987 15.9061L12.4955 17.1727C11.9938 18.0815 11.0356 18.6449 9.99522 18.6449C8.95481 18.6449 7.99665 18.0815 7.49496 17.1644L6.79999 15.8979L10.0034 10.0173L13.1863 4.16968L14.6339 1.51315C15.3987 0.135542 17.1341 -0.366155 18.5117 0.398727C19.8893 1.16361 20.391 2.89899 19.6261 4.2766H19.6344L19.6303 4.27248Z"
            fill="url(#paint0_linear_195_62)"
        />
        <path
            d="M6.82827 4.15626L3.57136 10.0245L0.367904 4.2344C-0.388753 2.84856 0.112942 1.11319 1.49055 0.352416C2.87639 -0.404241 4.61176 0.0974557 5.36842 1.47507L6.82005 4.16038H6.82827V4.15626Z"
            fill="url(#paint1_linear_195_62)"
        />
        <path
            d="M13.1847 4.16795L10.0018 10.0156L6.79836 15.8961L5.36729 18.5321C4.60241 19.9097 2.86703 20.4032 1.48531 19.6424C0.107703 18.8775 -0.385774 17.1422 0.374995 15.7645L3.562 10.0279L6.81892 4.15972L7.50156 2.93427C8.00325 2.02546 8.96141 1.46619 9.99359 1.46619C11.0258 1.46619 11.9839 2.02957 12.4856 2.93427L13.1724 4.17206L13.1806 4.16383L13.1847 4.16795Z"
            fill="url(#paint2_linear_195_62)"
        />
        <path
            d="M18.516 19.6392C18.076 19.8818 17.599 19.997 17.1302 19.997C16.1309 19.997 15.1522 19.4665 14.6299 18.5289L13.1989 15.8929L16.4434 10.0247L19.6263 15.7531C20.3912 17.1307 19.8936 18.8661 18.516 19.631V19.6392Z"
            fill="url(#paint3_linear_195_62)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_195_62"
                x1="8.42845"
                y1="19.3933"
                x2="17.4754"
                y2="1.80101"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0039FF" />
                <stop offset="1" stop-color="#01BAF9" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_195_62"
                x1="10.665"
                y1="16.6946"
                x2="2.02925"
                y2="1.43395"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0039FF" />
                <stop offset="1" stop-color="#01BAF9" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_195_62"
                x1="11.7249"
                y1="1.81573"
                x2="0.802677"
                y2="20.2305"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0039FF" />
                <stop offset="1" stop-color="#01BAF9" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_195_62"
                x1="13.5772"
                y1="10.7156"
                x2="19.1534"
                y2="20.8153"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0039FF" />
                <stop offset="1" stop-color="#01BAF9" />
            </linearGradient>
        </defs>
    </svg>
</template>
